<script>
  export let content = {
    homeschoolIconImgSrc: '',
    homeschoolIconImgAltTxt: '',
    homeschoolSectionTitleOne: '',
    homeschoolSectionTitleTwo: '',
    homeschoolSubTitle: '',
    homeschoolContentOne: ``,
    homeschoolContentTwo: ``,
    curriculumListItems: [
      {
        imgSrc: '',
        imgSrcAltTxt: '',
        title: ''
      }
    ]
  };
</script>

<section class="bg-[#F2F2F2] p-12 font-poppins">

  <div class="flex flex-col items-center mb-12">
    <img loading="lazy" class="w-[2.5rem] sm:w-[4.5rem] md:w-20" src="{content.homeschoolIconImgSrc}" alt="{content.homeschoolIconImgAltTxt}" />
    <h2 class="bg-gradient-to-r from-[#0395FF] via-[#156FF7] to-[#0494F5] bg-clip-text text-transparent text-[3rem] font-bold leading-[unset] pb-[0.5rem] text-center sm:text-[4.5rem] md:text-[5rem]">
      {content.homeschoolSectionTitleOne}
    </h2>
    <h2 class="bg-gradient-to-r from-[#0395FF] via-[#156FF7] to-[#0494F5] bg-clip-text text-transparent text-[3rem] font-bold pb-[0.5rem] text-center sm:text-[4.5rem] md:text-[5rem]">
      {content.homeschoolSectionTitleTwo}
    </h2>
  </div>

  <div class="grid grid-cols-1 gap-14 justify-items-center">

    <div class="grid grid-cols-1 gap-[3rem] text-center max-w-[43rem] sm:max-w-[61.5rem] md:max-w-[88rem]">
      <h3 class="text-[#63637A] text-[2rem] font-semibold sm:text-[3.5rem] tracking-normal leading-none">{content.homeschoolSubTitle}</h3>
      <p class="text-[#63637A] text-[1.4rem] leading-[1.7rem] sm:text-[2rem] sm:leading-[2.8rem] md:text-[2.2rem] md:leading-[3rem]">{content.homeschoolContentOne}</p>
      <p class="text-[#63637A] text-[1.4rem] leading-[1.7rem] sm:text-[2rem] sm:leading-[2.8rem] md:text-[2.2rem] md:leading-[3rem]">{content.homeschoolContentTwo}</p>
    </div>

    <div class=" flex flex-wrap items-center justify-center gap-[2rem] max-w-[32rem] sm:gap-12 sm:max-w-[57rem] sm:mb-[1rem] md:max-w-[84rem] lg:max-w-none">
      {#each content.curriculumListItems as item}
        <div class="grid grid-cols-1 gap-[1rem] justify-items-center">
          <img loading="lazy" class="school-image w-[14.2rem] sm:w-[23.4rem]" src="{item.imgSrc}" alt="{item.imgSrcAltTxt}" />
          <h4 class="school-image-title text-[#0158C3] text-[1.3rem] font-semibold sm:text-[2.1rem]">{item.title}</h4>
        </div>
      {/each}
    </div>
  </div>
</section>
